export default __webpack_public_path__ + "static/media/powerPanel.d563fcb1.png";